import './ErrorPage.scss';
import { IErrorPageProps } from "../../model/interface";

export default function ErrorPage({errorHeader, errorSubText}: IErrorPageProps) {
    return (
        <div className="error-page">
            <div className="error-page-overview">
                <h2 data-testid="errorPageHeader">{errorHeader}</h2>
                <span>{errorSubText}</span>
            </div>
        </div>
    );
};